/**
 * @generated SignedSource<<29623af7f5fdb0ebd9141d5c2ea501fa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TodoCategoryIcon = "Check" | "Message" | "Order" | "Sun";
export type useWidgetCategoriesQuery$variables = Record<PropertyKey, never>;
export type useWidgetCategoriesQuery$data = {
  readonly store: {
    readonly defaultTodoCategory: {
      readonly icon: TodoCategoryIcon | null;
      readonly id: string;
      readonly title: string;
    } | null;
    readonly isPartOfOrg: boolean;
    readonly " $fragmentSpreads": FragmentRefs<"useHasFeatureInTier_Store">;
  };
};
export type useWidgetCategoriesQuery = {
  response: useWidgetCategoriesQuery$data;
  variables: useWidgetCategoriesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPartOfOrg",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "TodoCategory",
  "kind": "LinkedField",
  "name": "defaultTodoCategory",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "icon",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useWidgetCategoriesQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "useHasFeatureInTier_Store"
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useWidgetCategoriesQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "tier",
            "storageKey": null
          },
          (v2/*: any*/),
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "fa768d2248d97c712efdf2713d4fe09f",
    "id": null,
    "metadata": {},
    "name": "useWidgetCategoriesQuery",
    "operationKind": "query",
    "text": "query useWidgetCategoriesQuery {\n  store {\n    isPartOfOrg\n    ...useHasFeatureInTier_Store\n    defaultTodoCategory {\n      id\n      title\n      icon\n    }\n    id\n  }\n}\n\nfragment useHasFeatureInTier_Store on Store {\n  tier\n}\n"
  }
};
})();

(node as any).hash = "fc7c5099594b7f0b58cc77845e00eb44";

export default node;
